<template>
  <div v-if="!isLoading">
    <div>
      <div class="row mx-0 mt-2 mb-3 justify-content-between">
        <div class="main-color-text bold-text"> {{ $t('operation.bilan.Honoraires').toUpperCase() }}</div>
        <div class="row mx-0 align-items-center">
          <div class="row mx-0 align-items-center">
            <b-link class="main-color-text bold-text ml-3" v-on:click="clickOnEditBtn()">
              {{ $t('Modify') }}
              <pencil-icon size="18"/>
            </b-link>
          </div>
        </div>
      </div>
      <b-table id="table-construction" ref="table"
               :fields="tableFieldsHonoraires"
               :items="itemsHonoraires"
               :tbody-tr-class="rowClass"
               :thead-class="'row-header'"
               borderless
               class="light-border"
               striped>
        <template #cell(type)="data">
          {{ $t(data.value) }}
        </template>
        <template #cell(HT)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TVA)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TTC)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

import api from "../../../services/api";

export default {
  name: "OperationShowHonoraires",

  components: {},

  props: {
    operationId: {
      default: null
    },
    operationBilanId: {
      default: null
    },
    simulationId: {
      default: null
    }
  },

  data() {
    return {
      needFacture: false,
      isLoading: false,
      tableFieldsHonoraires: [
        {label: '', key: 'type'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsHonoraires: [],
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {

    async fetchData() {
      await this.getOperationBilanType()
      await this.getHonorairesData()
    },

    clickOnDevisBtn() {
      this.$router.push({
        name: 'OperationDevisIndex',
        params: {
          operationId: this.operationId,
        }
      })
    },

    clickOnFacturesBtn() {
      this.$router.push({
        name: 'OperationFactureIndex',
        params: {
          operationId: this.operationId,
        }
      })
    },


    async getOperationBilanType() {
      this.isLoading = true
      api
        .get(`/operationBilan/getOperationBilanType/${this.operationBilanId}`)
        .then(response => {
          if (response.data.bilanType === 'EXE') {
            this.needFacture = true
          }
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
            })
          }
        })
    },

    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'title-section-margin') return 'row-title-section row-margin'
      if (item.status === 'title-section') return 'row-title-section'
      else if (item.status === 'total-primary') return 'row-total-primary'
      else if (item.status === 'total-grey') return 'row-total-grey'
      else if (item.status === 'subtitle') return 'bold-text main-red-color'
    },

    async getHonorairesData() {
      this.isLoading = true
      api
        .get(`/operationBilan/getHonorairesData/${this.operationId}`)
        .then(response => {
          this.itemsHonoraires = response.data['itemsHonoraires']
          this.isLoading = false
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
            })
          }
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'OperationBilanHonorairesEdit',
        params: {
          operationId: this.operationId,
          operationBilanId: this.operationBilanId,
          simulationId: this.simulationId
        }
      })
    },

  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowHonoraires.vue